import {
    AbstractControl,
    ValidationErrors,
} from '@angular/forms';

import * as XRegExp from 'xregexp';

export function regex(_regex: RegExp | string, allowEmpty = false) {
    const regX = typeof _regex === 'string' ? XRegExp(_regex) : _regex;
    return (c: AbstractControl) => {
        return ((allowEmpty && (c.value == null || c.value === '')) || regX.test(c.value)) ?
            null :
            {
                regex: {
                    valid: false,
                },
            } as ValidationErrors;
    };
}
